import React from 'react';
import PropTypes from 'prop-types';
import ArticleBox from '../articleBox';
import ArticleBoxLoader from '../articleBox/articleBoxLoader';
import {
	Container, Columns,
	H1
} from '../base';
import * as StyledArticleList from './articleList.styles';

const ArticleList = ({
	articles,
	loading,
	error
}) => {
	// TODO: Error
	return (
		<StyledArticleList.Wrapper>
			<Container>
				{
					error && <h1>Error</h1>
				}
				<H1 marginBottom>Fréttayfirlit</H1>
				<Columns>
					{
						loading && !error && [...Array(10)].map((value, index) => (
							<StyledArticleList.AnimatedColumn
								tablet={1 / 2}
								desktopSmall={1}
								desktopLarge={1 / 2}
								key={index}>
								<ArticleBoxLoader />
							</StyledArticleList.AnimatedColumn>
						))
					}
					{
						!loading && !error && articles && articles.map(article => (
							<StyledArticleList.AnimatedColumn
								tablet={1 / 2}
								desktopSmall={1}
								desktopLarge={1 / 2}
								key={article.Id}>
								<ArticleBox {...article} />
							</StyledArticleList.AnimatedColumn>
						))
					}
				</Columns>
			</Container>
		</StyledArticleList.Wrapper>
	);
};

ArticleList.propTypes = {
	articles: PropTypes.array,
	loading: PropTypes.bool,
	error: PropTypes.bool
};

ArticleList.defaultProps = {
	articles: [],
	loading: false,
	error: false
};

export default ArticleList;
